import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
import { HttpClient } from '@angular/common/http';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ViewCartService {
  public isLoggedIn: boolean = false;
  public server = environment.APIEndpoint;
  public CartGuesttoken = localStorage.getItem('guestUserToken');
  public authType = 'Bearer';
  //::::::API EndPoints:Start::::::
  public urls: any = {
    getactiveBasket: this.server + 'api/order/cart/active/v2/get',
    getactiveBasketUnsec: this.server + 'api/unsec/order/cart/active/v2/get',
    createbasket: this.server + 'app/createBasket/v1',
    createbasketUnsec: this.server + 'api/unsec/order/cart/v1/create',
    addItemInBasket: this.server + 'app/addItemToBasket/v2',
    addItemInBasketUnsec: this.server + 'api/unsec/order/cart/item/v1/add',
    getbasket: this.server + 'api/kiosk/order/cart/v1/get?basketId=',
    getbasketUnsec: this.server + 'api/unsec/order/cart/v2/get?basketId=',
    updateLineItem: this.server + 'app/updateLineItem/v1',
    updateLineItemUnsec: this.server + 'api/unsec/order/cart/item/v1/update',
    crossAndUpSell: this.server + 'api/unsec/cms/crossAndUpSell/v1/products',
    deleteLineItem: this.server + 'api/cart/v1/deleteLineItem?',
    deleteLineItemUnsec: this.server + 'api/unsec/order/cart/item/v1/delete?',
    deletebasket: this.server + 'app/deleteBasket/v1?basketId=',
    deleteBasketUnsecure: this.server + 'api/unsec/order/cart/v1/delete?basketId=',
    deletebasketLineItem: this.server + 'api/cart/v1/deleteLineItem?',
    guestUserToken: this.server + 'api/unsec/user/guest/v2/token',
    cartUpdate: this.server + 'api/order/cart/customer/v1/update'
  }
  //::::::API EndPoints:End::::::
  constructor(private http: HttpClient, private commonFunction: CommonFunctions,private apiHeader: ApiHeaderService) {}
  //::::::meto info:::::::
  public metaInfo = {
    "appVersion": "v1.0.0",
    "deviceCountry": "India",
    "deviceCity": "",
    "deviceId": localStorage.getItem("deviceId") ? localStorage.getItem("deviceId") : '',
    "deviceModel": "",
    "platform": "WEB",
    "deviceOSVersion": ""
  }
  //::::::API Methods::Start:::::
  getBasket() {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.getBasket, { headers: secHeaders });
  }
  getGuestUserToken() {
    let unsecHeaderData = {
      'Accept-Language': 'EN',
      'Device-Meta-Info': JSON.stringify(this.metaInfo)
    }
    let requestPayload = {
      deviceToken: localStorage.getItem('firebaseDeviceId')
    }
    return this.http.post(this.urls.guestUserToken, requestPayload, { headers: unsecHeaderData });
  }
  getActiveBasket() {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.getactiveBasket, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.getactiveBasketUnsec, { headers: unsecureHeaders });
    }
  }
  createBasket(requestPayload) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.createbasket, requestPayload, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.createbasketUnsec, requestPayload, { headers: unsecureHeaders });
    }
  }
  addItemToBasket(requestPayload) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.addItemInBasket, requestPayload, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.addItemInBasketUnsec, requestPayload, { headers: unsecureHeaders });
    }
  }
  getbasketItem(requestPayload) {
    let basketId = requestPayload['basketId']
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.getbasket + basketId, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.getbasketUnsec + basketId, { headers: unsecureHeaders });
    }
  }
  updateLineItem(requestData) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.updateLineItem, requestData, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.updateLineItemUnsec, requestData, { headers: unsecureHeaders });
    }
  }
  deleteBasket(requestPayload) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.delete(this.urls.deletebasket + requestPayload.basketId, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.delete(this.urls.deleteBasketUnsecure + requestPayload.basketId, { headers: unsecureHeaders });
    }
  }
  deleteLineItem(requestData) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.delete(this.urls.deleteLineItem + 'basketId=' + requestData['basketId'] + '&lineItemId=' + requestData['lineItemId'], { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.delete(this.urls.deleteLineItemUnsec + 'basketId=' + requestData['basketId'] + '&lineItemId=' + requestData['lineItemId'], { headers: unsecureHeaders });
    }
  }
  removeLineItemFromCart(requestData) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.delete(this.urls.deletebasketLineItem + 'basketId=' + requestData['basketId'] + '&lineItemId=' + requestData['lineItemId'], { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.delete(this.urls.deleteLineItemUnsec + 'basketId=' + requestData['basketId'] + '&lineItemId=' + requestData['lineItemId'], { headers: unsecureHeaders });
    }
  }
  crossAndUpSell(requestData) {
    let unsecureHeaders = this.apiHeader.getUnSecureHeader();
    return this.http.post(this.urls.crossAndUpSell, requestData, { headers: unsecureHeaders });
  }
  updateBasket(requestData){
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (isLoggedIn) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.cartUpdate, requestData, { headers: secHeaders });
    }
  }
  private cartcleared = new Subject()
  sendCartInfo(data) {
    this.cartcleared.next(data);
  }
  getCartInfo(): Observable<any> {
    return this.cartcleared.asObservable()
  }
  //::::::API Methods::End:::::
}
